import React from 'react'
import { messageyou } from '../../../../assets'

const index = ({children, value}) => {
  return (
    <div className='flex  flex-col items-start'>
      {
        children &&
        <div className='overflow-hidden ml-[15px] border-solid border-gray-borderGray rounded-[10px] border-[4px]'>
        <div className='bg-gray-borderGray  sm:max-w-[450px] flex justify-center items-center max-w-[200px]  rounded-[30px]'>{children}</div>
        </div>
      }{
        value &&
        <div className='bg-gray-borderGray  sm:max-w-[450px] flex justify-center items-center max-w-[200px] px-[12px] py-[6px] ml-[15px] rounded-[30px]'>{value}</div>
      }
        <div className='ml-[24px] mt-[-1px]'><img src={messageyou} alt="" /></div>
    </div>
  )
}

export default index